import type { ApiResponse, Branding } from '~/types'

export const useGetBranding = async () => {
  const { $api } = useNuxtApp()
  const brandingStore = useBrandingStore()

  if (brandingStore.branding) {
    return {
      data: brandingStore.branding,
      status: 'success',
      message: 'Success',
    }
  }

  try {
    const response = await $api<ApiResponse<Branding>>('brandings', {
      method: 'GET',
    })

    if (response.data) {
      brandingStore.setBranding(response.data)
    }

    return response
  } finally {
    brandingStore.setLoaded(true)
  }
}
